import { createAsyncThunk, createSlice, ActionReducerMapBuilder } from '@reduxjs/toolkit';
import axios from 'axios';
import { IBrand } from '../../../../interfaces';
import store from '../../../app/Store';

const VENDOR_MC_URL = `${process.env.REACT_APP_API_PIM_URL}`;

interface IMapped {
  value: string;
  label: string;
}

interface IState {
  data: IBrand[];
  mappedData: IMapped[];
  loading: boolean;
  done: boolean;
  showError: boolean;
  error: any;
}

const initialState: IState = {
  data: [],
  loading: false,
  mappedData: [],
  done: false,
  showError: false,
  error: null,
};

export const getBrandList = createAsyncThunk('vendor-brand/list', async () => {
  const vendorId = store.getState().auth?.user?.vendor?.id;
  const res = await axios.get<IBrand[]>(`${VENDOR_MC_URL}/${vendorId}/brand/list`);
  return res.data;
});

const brandListSlice = createSlice({
  name: 'vendor-brand',
  initialState,
  reducers: {},
  extraReducers: (builder: ActionReducerMapBuilder<IState>) => {
    builder.addCase(getBrandList.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(getBrandList.fulfilled, (state, action) => {
      state.data = action.payload;
      state.mappedData = action.payload.map((item) => {
        return {
          value: item.id.toString(),
          label: item.title,
        };
      });
      state.loading = false;
      state.done = true;
    });
    builder.addCase(getBrandList.rejected, (state, action) => {
      state.error = 'Brand List Error!';
      state.showError = true;
    });
  },
});

export default brandListSlice.reducer;
